import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class RubroService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerRubros(rutEmpresa, callback) {
        this.gqlclient.query({
            query: gql `
        query($empresa_rut: Decimal) {
          rubro {
            obtenerRubros(empresa_rut: $empresa_rut) {
              respuesta {
                registros {
                  empresa_rut
                  codigo
                  descripcion
                  activo
                }
              }
            }
          }
        }
        `,
            variables: {
                empresa_rut: rutEmpresa,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro.obtenerRubros;
            callback({ mensajes, respuesta });
        });
    }
    obtenerRubrosReporteVenta(rutEmpresa, callback) {
        this.gqlclient.query({
            query: gql `
        query($empresa_rut: Decimal) {
          rubro {
            obtenerRubrosReporteVenta(empresa_rut: $empresa_rut) {
              respuesta {
                registros {
                  empresa_rut
                  codigo
                  descripcion
                  activo
                }
              }
            }
          }
        }
        `,
            variables: {
                empresa_rut: rutEmpresa,
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro.obtenerRubrosReporteVenta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: rubroInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          rubro {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                registros {
                  empresa_rut
                  codigo
                  descripcion
                  activo
                }
                totalPaginas
                totalRegistros
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    guardar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: rubroInputType) {
          rubro {
            guardar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                descripcion
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro.guardar;
            callback({ mensajes, respuesta });
        });
    }
    cambiaEstado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: rubroInputType) {
          rubro {
            cambiaEstado(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.rubro.cambiaEstado;
            callback({ mensajes, respuesta });
        });
    }
}
RubroService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RubroService_Factory() { return new RubroService(i0.ɵɵinject(i1.GraphQLClient)); }, token: RubroService, providedIn: "root" });
